import { createSlice } from "@reduxjs/toolkit";
import { getListTrademark } from "../../api/Trademark/Trademark";

// giá trị khởi tạo của state
const initialState = {
  listTrademark: [],
  isLoadTrademark: false,
  currentPage: 1,
  pageSize: 10,
  // hasFetchedData: false,
  error: null,
  totalRecords: 0, // Tổng số bản ghi từ API  
};

const trademarkSlice = createSlice({
  name: "trademark", // tên phân biệt giữa các reduce
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload; // Sửa lỗi gán nhầm `pageSize`
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListTrademark.pending, (state) => {// api đnag pending chờ xử lý
        state.isLoadTrademark = true;
        state.error = null;
      })
      .addCase(getListTrademark.fulfilled, (state, action) => {// api trả về thành công thì trả ra
        state.isLoadTrademark = false;
        state.listTrademark = action.payload.data || [];

        state.isLoadTrademark = false;
        // state.hasFetchedData = true;
        state.currentPage = action.payload.current_page; // Cập nhật trang hiện tại từ API
        state.pageSize = action.payload.per_page; // Cập nhật số bản ghi mỗi trang
        state.totalRecords = action.payload.total; // Cập nhật tổng số bản ghi
      })
      .addCase(getListTrademark.rejected, (state, action) => {// api trả về thất bại thì trả ra
        state.isLoadTrademark = false;
        state.error = action.payload;
        // state.error = action.error?.message || "Lỗi không xác định";
      });
  },
});

export const { setCurrentPage, setPageSize, setTotalRecords } = trademarkSlice.actions;
export default trademarkSlice.reducer;
